//#region src/types/geolocation.ts
const STORAGE_PREFIX = "geolocation";

//#endregion
export { STORAGE_PREFIX };